// services
const ADMIN = 'admin';

// endpoints
export const ENDPOINTS = {
  // auth
  login: 'oauth2/token',
  // admin
  fetchBoard: `${ADMIN}`,
  importFile: `${ADMIN}/import`,
  checkFileStatus: `${ADMIN}/status`,
  downloadReportByUUID: uuid => `${ADMIN}/report/${uuid}`,
  // report-config
  reportConfig: `${ADMIN}/report-config`,
  getReportConfigByUUID: uuid => `${ADMIN}/report-config/${uuid}`,
};
